const dev = false; // When running "npm run dev"
const build = false; // When running "npm run build" to test locally (not deployed)

const prefix = dev ? '' : build ? '/wp-content/themes/twentytwentyfive-child/dist' :  '/wp-content/themes/berliner-fernsehturm/dist';

export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            `${prefix}/textures/hdr/px.png`,
            `${prefix}/textures/hdr/nx.png`,
            `${prefix}/textures/hdr/py.png`,
            `${prefix}/textures/hdr/ny.png`,
            `${prefix}/textures/hdr/pz.png`,
            `${prefix}/textures/hdr/nz.png`
        ]
    },
    {
        name: 'sphereModel',
        type: 'gltfModel',
        path: `${prefix}/models/sphere.glb`
    },
    {
        name: 'font',
        type: 'font',
        path: `${prefix}/font/poppins.json` // Replace with your font path
    },
]